import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import { MONTHS, fmtCompact } from "@/lib/format";

export const BudgetChart = ({ kpis, actualYear, budgetYear, lastMonth }) => {
  const rev = kpis?.revenue;
  const gop = kpis?.gop;
  if (!rev) return null;
  const data = MONTHS.map((m, i) => ({
    name: m, fy: rev.fy?.[i] ?? 0, budget: rev.budget?.[i] ?? 0,
    gopFy: gop?.fy?.[i] ?? 0, gopBudget: gop?.budget?.[i] ?? 0, forecast: i >= lastMonth,
  }));
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-5" data-testid="budget-chart">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-semibold text-slate-900">Revenue &amp; GOP: FY {actualYear} Est vs Budget {budgetYear}</h3>
        <p className="text-[11px] text-slate-500">Months ≥ {MONTHS[lastMonth] || "-"} {actualYear} = forecast</p>
      </div>
      <div className="h-72 mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barGap={2} barCategoryGap="22%">
            <CartesianGrid vertical={false} stroke="#E2E8F0" />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} />
            <YAxis tickFormatter={fmtCompact} tick={{ fontSize: 10, fill: "#64748B", fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} width={64} />
            <Tooltip formatter={(v) => fmtCompact(v)} contentStyle={{ fontSize: 12, borderRadius: 8, borderColor: "#E2E8F0" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="fy" name={`Revenue FY ${actualYear}`} fill="#94A3B8" radius={[3, 3, 0, 0]} />
            <Bar dataKey="budget" name={`Revenue Budget ${budgetYear}`} fill="#059669" radius={[3, 3, 0, 0]} />
            {gop && <Bar dataKey="gopBudget" name={`GOP Budget ${budgetYear}`} fill="#D97706" radius={[3, 3, 0, 0]} />}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
